import React from 'react';
import { MdLogin, MdLogin as MdLoginRaw } from 'react-icons/md';

type Props = {
    onClick: () => void;
};

export default function LoginButton({ onClick }: Props) {
    const MdLogin = MdLoginRaw as unknown as React.FC<React.SVGProps<SVGSVGElement>>;

    return (
        <div className="login-button-container">
            <button className="text-icon-button button-text" onClick={onClick}>
                <div>Login</div>
                <MdLogin />
            </button>
        </div>
    );
}
